import {
  getScheduleStatusKind,
  hasScheduleStatusOffTolerance,
  SCHEDULE_STATUS_FILTER_ORDER,
  ScheduleStatusCoverage,
  ScheduleStatusFilterValue,
} from './get-schedule-status-kind';

export interface ScheduleStatusCounts {
  total: number;
  byFilter: Record<ScheduleStatusFilterValue, number>;
}

/** Counts rows by coverage kind. Off-tolerance is a flag and can overlap Completo/Parcial. */
export function getScheduleStatusCounts(
  items: readonly { status: ScheduleStatusCoverage }[],
): ScheduleStatusCounts {
  const byFilter = Object.fromEntries(
    SCHEDULE_STATUS_FILTER_ORDER.map((value) => [value, 0]),
  ) as Record<ScheduleStatusFilterValue, number>;

  for (const item of items) {
    byFilter[getScheduleStatusKind(item.status)] += 1;

    if (hasScheduleStatusOffTolerance(item.status)) {
      byFilter.offTolerance += 1;
    }
  }

  return {
    total: items.length,
    byFilter,
  };
}
